export default "__VITE_ASSET__BDspbOZx__"